import { render, staticRenderFns } from "./duplicate-project.vue?vue&type=template&id=7f3d5e0d"
import script from "./duplicate-project.vue?vue&type=script&lang=js"
export * from "./duplicate-project.vue?vue&type=script&lang=js"
import style0 from "./duplicate-project.vue?vue&type=style&index=0&id=7f3d5e0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports